/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import {
  setProductGroupsList,
  setViewedProductGroup,
  fetchSingleProductGroup,
  setErrorMessage,
} from './actions';

const associationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setViewedProductGroup, (state, action) => {
      state.viewedProductGroup = action.payload.viewedProductGroup;
    })
    .addCase(setProductGroupsList, (state, action) => {
      state.productGroupsList = action.payload.productGroupsList;
    })
    .addCase(setErrorMessage, (state, action) => {
      state.errorMessage = action.payload.errorMessage;
    })
    .addCase(fetchSingleProductGroup, (state, action) => {
      state.viewedProductGroup = action.payload.productGroupNumber;
    });
});

export default associationsReducer;
